import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { string, shape } from 'prop-types'

import { view, createStore, stores } from '../../stores'
import { Pages } from '../../constants/Pages'
import { HeaderComponent } from './HeaderComponent'

class HeaderContainer extends Component {
  constructor () {
    super()
    this.store = createStore({
      menuIsOpen: false
    })

    this.onOpenMenu = () => { this.store.menuIsOpen = !this.store.menuIsOpen }
    this.onCloseMenu = () => { this.store.menuIsOpen = false }
  }

  get page () {
    const path = this.props.location.pathname.split('/')[1]
    const page = Pages.find((p) => p.page === path)
    if (page) return page.name
    return page
  }

  render () {
    return (
      <HeaderComponent
        onOpenMenu={() => this.onOpenMenu()}
        closeMenu={() => this.onCloseMenu()}
        isMenuOpen={this.store.menuIsOpen}
        activePage={this.page}
        isConnected={stores.authentication.isAuthententicated()}
        account={stores.account}
        seo={stores.metadata.values}
      />
    )
  }
}

HeaderContainer.propTypes = {
  location: shape({ pathname: string })
}

export const Header = withRouter(view(HeaderContainer))



// WEBPACK FOOTER //
// ./src/components/header/Header.js